import Marquee from "react-fast-marquee";
import { Container, FadeUp } from "./primitives";

const CATEGORIES = [
  "Marketing Agencies",
  "Founders",
  "Sales Teams",
  "Creators",
  "Digital Consultants",
  "B2B SaaS",
  "Growth Studios",
  "Recruiters",
];

const LOGOS = [
  "NORTHWIND", "OCTAVE", "MERIDIAN", "PARALLEL", "ARC/LABS",
  "HELIX", "STRATA", "CANOPY", "FORGE&FIELD", "LINEAGE",
  "OBSIDIAN", "REVERB",
];

export default function SocialProof() {
  return (
    <section data-testid="social-proof" className="relative py-24 md:py-28 border-t border-white/10">
      <Container>
        <FadeUp>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div>
              <div className="font-mono-x text-xs tracking-[0.24em] text-white/40 uppercase">
                Trusted by ambitious teams
              </div>
              <h3 className="mt-3 font-display text-2xl md:text-3xl tracking-[-0.02em] max-w-lg leading-tight">
                From{" "}
                {CATEGORIES.slice(0, 3).map((c, i) => (
                  <span key={c}>
                    <span className="text-white/85">{c.toLowerCase()}</span>
                    {i < 2 ? <span className="text-white/40">, </span> : null}
                  </span>
                ))}{" "}
                to <span className="font-serif-x italic text-white">enterprise sales orgs</span>.
              </h3>
            </div>
            <div className="flex flex-wrap gap-2">
              {CATEGORIES.map((c) => (
                <span key={c} className="chip">{c}</span>
              ))}
            </div>
          </div>
        </FadeUp>

        <div className="mt-14 relative">
          <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[var(--bg)] to-transparent z-10" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[var(--bg)] to-transparent z-10" />
          <Marquee gradient={false} speed={40} pauseOnHover>
            {LOGOS.concat(LOGOS).map((l, i) => (
              <div
                key={`${l}-${i}`}
                className="mx-10 flex items-center gap-2 select-none opacity-50 hover:opacity-100 transition-opacity"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-white/40" />
                <span className="font-display text-2xl md:text-3xl tracking-[-0.02em] text-white/70">
                  {l}
                </span>
              </div>
            ))}
          </Marquee>
        </div>
      </Container>
    </section>
  );
}
